import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=ef15b408&scoped=true"
import script from "./Partners.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Partners.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Partners.vue?vue&type=style&index=0&id=ef15b408&prod&lang=scss"
import style1 from "./Partners.vue?vue&type=style&index=1&id=ef15b408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef15b408",
  null
  
)

export default component.exports